import {
  REQUEST as req,
  RESPONSE as res,
  FAILURE as fail,
  CLEAR as clr,
} from '../../actions/signals/list';

const initialState = {
  response: {
    signals: [],
    correlations: {
        correlation: {},
        granger: {}
    },
    pagination: {
      total_pages: 0,
      total_items: 0,
      current_page: 1,
      per_page: 100
    },
    isLoading: true,
    error: null
}
};
export const reducer = (state = initialState, action) => {
  switch (action.type) {
    case req:
      return {
        ...state,
        isLoading: true,
        error: null
      };
    case res:
      return {
        ...state,
        isLoading: false,
        response: action.payload
      };
    case fail:
      return {
        ...state,
        isLoading: false,
        error: action.payload
      };
    case clr:
      return {
        ...state,
        response: null,
        isLoading: false,
        error: null
      };
    default:
      return state;
  }
};